angular.module('bizPartEngage').directive('bizSimpleWelcomeGuide', bizSimpleWelcomeGuide);
angular.module('bizPartEngage').directive('bizWelcomeGuideJourneySelector', bizWelcomeGuideJourneySelector);
angular.module('bizPartEngage').service('bizWelcomeGuideService', bizWelcomeGuideService);

bizWelcomeGuideJourneySelector.$inject = ["bizCore"];
bizSimpleWelcomeGuide.$inject = ["bizCore"];
bizWelcomeGuideService.$inject = ["$http"];

function bizWelcomeGuideJourneySelector(bizCoreProvider) {
    var directive = {
        restrict: "E",
        scope: {
            
        },
        templateUrl: function (element, attr) {
            if (attr.templateurl) {
                return siteRootPath + attr.templateurl;
            }
            else {
                return bizCoreProvider.getView('core.directives.welcomeguidejourneyselector', "FrontEnd/Core/Directives/Views/WelcomeGuideJourneySelector.html");
            }
        },
        bindToController: true,
        controller: bizWelcomeGuideJourneySelectorController,
        controllerAs: "vm"
    };

    bizWelcomeGuideJourneySelectorController.$inject = ["$rootScope", "bizWelcomeGuideService", "$q", "$attrs"];

    function bizWelcomeGuideJourneySelectorController($rootScope, bizWelcomeGuideService, $q, $attrs) {
        var vm = this;
        vm.Init = Init;
        vm.SelectJourney = SelectJourney;
        vm.MaxJourneys = 99;

        function SelectJourney(journey) {
            vm.SelectedJourney = journey;
            $rootScope.$broadcast('WELCOMEGUIDE.SELECT_JOURNEY', journey);
        }

        function Init() {
            var qsPermFilter = getParameterByNameFromUrl('perms', location.href);
            var pList = [];
            pList.push($rootScope.JourneysInitialized);
            if (qsPermFilter) {
                qsPermFilter = decodeURI(qsPermFilter);
                pList.push(bizWelcomeGuideService.GetItemsByPermissionCombination(qsPermFilter));
            }
            
            $q.all(pList).then((result) => {
                var filterJourneyCollectionIds;
                if (result.length > 1) {
                    filterJourneyCollectionIds = BizPartCoreHelpers.getResponseValue(result[1]);
                }

                if ($attrs.max) {
                    vm.MaxJourneys = ~~$attrs.max;//cant get this working via scope for textviewer :(
                }

                if ($attrs.col == 2) {
                    vm.Wrap = true;
                }

                if ($rootScope.Journeys) {
                    vm.Journeys = [];
                    for (var i = 0; i < $rootScope.Journeys.length; i++) {
                        var journey = $rootScope.Journeys[i];
                        if (!filterJourneyCollectionIds || filterJourneyCollectionIds.indexOf(journey.JourneyCollectionId) >= 0) {
                            vm.Journeys.push(journey);
                        }                        
                    }
                }
            });
        }

        vm.$onInit = vm.Init;
    }

    return directive;
}

function bizSimpleWelcomeGuide(bizCoreProvider) {
    var directive = {
        restrict: "E",
        scope: {
            pages: "="
        },
        templateUrl: function (element, attr) {
            if (attr.templateurl) {
                return siteRootPath + attr.templateurl;
            }
            else {
                return bizCoreProvider.getView('core.directives.simplewelcomeguide', "FrontEnd/Core/Directives/Views/SimpleWelcomeGuide.html");
            }
        },        
        bindToController: true,
        controller: bizSimpleWelcomeGuideController,
        controllerAs: "vm"
    };

    bizSimpleWelcomeGuideController.$inject = ["$rootScope", "$scope", "$timeout", "core.portal.service", "$filter"];

    function bizSimpleWelcomeGuideController($rootScope, $scope, $timeout, portalService, $filter) {
        var vm = this;        

        vm.Init = Init;
        vm.LoadWelcomeGuide = LoadWelcomeGuide;
        vm.TriggerNext = TriggerNext;
        vm.TriggerPrev = TriggerPrev;
        vm.LoadCustomPlaceholders = LoadCustomPlaceholders;
        
        vm.SlickSettings = {
            autoplay: false,            
            dots: false,
            arrows: false,
            infinite: false,
            mobileFirst: true,            
            method: {}
        }

        function TriggerNext(last) {            
            if (last) {                
                $rootScope.$broadcast('WELCOMEGUIDE.COMPLETED', { SelectedJourney: vm.SelectedJourney });
            } else {                
                $timeout(function () {
                    $("#welcome-guide-slick").slick('slickNext');
                });
            }            
        }

        function TriggerPrev() {            
            $timeout(function () {
                $("#welcome-guide-slick").slick('slickPrev');
            });
        }

        function LoadCustomPlaceholders() {            

            vm.CustomPlaceholders = [
                {
                    Name: "Journey selection",
                    Regex: /##JOURNEYSELECTION-COL(.*?)-MAX(.*?)##/gmi,
                    Content: '<biz-welcome-guide-journey-selector col="$1" max="$2"></biz-welcome-guide-journey-selector>'
                }
            ];
        }

        function LoadWelcomeGuide() {
            if (vm.pages) {                
                InitWelcomeGuide();
            } else {
                portalService.GetPortalSetting("WELCOMEGUIDE_DATA").then(GetPagesCallback);                
                function GetPagesCallback(response) {
                    var data = JSON.parse(response.data);
                    vm.pages = data.pages;
                    InitWelcomeGuide();
                }
            }

            function InitWelcomeGuide() {                
                $timeout(function () {
                    vm.SlickDataLoaded = true;
                });
            }
            
        }

        function Init() {            
            vm.LoadCustomPlaceholders();
            vm.LogoUrl = $filter('siteroot')(portalSettings['logo']);
            vm.LoadWelcomeGuide();

            $rootScope.$on('WELCOMEGUIDE.SELECT_JOURNEY', function (e, journey) {
                vm.SelectedJourney = journey;
            });            
        }

        vm.$onInit = vm.Init;
    }

    return directive;
}

function bizWelcomeGuideService($http) {
    this.GetItemsByPermissionCombination = function (combStr) {
        return $http.get(siteRootPath + "api/permission/GetItemsByPermissionCombination?key=JOURNEY_COLLECTION&permCombId=" + combStr);
    }
}